import { MASTER_DATA } from "../constants";

const initialState = {
    regionMaster: [],
    airportMaster: [],
    countryMaster: [],
    airportCodeMaster: [],
    productsMaster: [],
    shippingItemsMaster: [],
    additionalSccsMaster: [],
    airportsMaster: [],
    sccMaster: [],
    servicesMaster: [],
    uldTypeByCodeMaster: [],
    uldTypesMaster: [],
    termsCountriesMaster: [],
    chargeHeadsMaser: [],
    currencyListMaster: [],
    sccListMaster: [],
    unidListMaster: [],
    

};

export default function (state = initialState, action) {
    switch (action.type) {
        case MASTER_DATA.SET_MASTER_DATA:
            const { regionMaster, airportMaster, countryMaster, airportCodeMaster, productsMaster, shippingItemsMaster, additionalSccsMaster, airportsMaster, sccMaster, servicesMaster, uldTypeByCodeMaster, uldTypesMaster,termsCountriesMaster,chargeHeadsMaser,currencyListMaster,sccListMaster,unidListMaster} = action.payload || {};
            return {
                ...state,
                regionMaster: regionMaster ?? state.regionMaster,
                airportMaster: airportMaster ?? state.airportMaster,
                countryMaster: countryMaster ?? state.countryMaster,
                airportCodeMaster: airportCodeMaster ?? state.airportCodeMaster,
                productsMaster: productsMaster ?? state.productsMaster,
                shippingItemsMaster: shippingItemsMaster ?? state.shippingItemsMaster,
                additionalSccsMaster: additionalSccsMaster ?? state.additionalSccsMaster,
                airportsMaster: airportsMaster ?? state.airportsMaster,
                sccMaster: sccMaster ?? state.sccMaster,
                servicesMaster: servicesMaster ?? state.servicesMaster,
                uldTypeByCodeMaster: uldTypeByCodeMaster ?? state.uldTypeByCodeMaster,
                uldTypesMaster: uldTypesMaster ?? state.uldTypesMaster,
                termsCountriesMaster: termsCountriesMaster ?? state.termsCountriesMaster,
                chargeHeadsMaser: chargeHeadsMaser ?? state.chargeHeadsMaser,
                currencyListMaster: currencyListMaster ?? state.currencyListMaster,
                sccListMaster: sccListMaster ?? state.sccListMaster,
                unidListMaster: unidListMaster ?? state.unidListMaster,
               
            };
        case MASTER_DATA.CLEAR:
            return {
                ...state,
                regionMaster: [],
                airportMaster: [],
                countryMaster: [],
                airportCodeMaster: [],
                productsMaster: [],
                shippingItemsMaster: [],
                additionalSccsMaster: [],
                airportsMaster: [],
                sccMaster: [],
                servicesMaster: [],
                uldTypeByCodeMaster: [],
                uldTypesMaster: [],
                termsCountriesMaster: [],
                chargeHeadsMaser: [],
                currencyListMaster: [],
                sccListMaster: [],
                unidListMaster: [],
                

            };
        default:
            return state;
    }
}
